export const LINK_LINKEDIN_OWNER_1 = "https://www.linkedin.com/in/wasimtahir/";
export const LINK_LINKEDIN_OWNER_2 = "https://www.linkedin.com/in/jonny-lewis/";
